import { render, staticRenderFns } from "./CreateCorral.vue?vue&type=template&id=0d105462&scoped=true"
import script from "./CreateCorral.vue?vue&type=script&lang=js"
export * from "./CreateCorral.vue?vue&type=script&lang=js"
import style0 from "./CreateCorral.vue?vue&type=style&index=0&id=0d105462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d105462",
  null
  
)

export default component.exports